import { makeStyles, tokens } from '@fluentui/react-components'

// The list and its wrapping container both need to shrink to fit whatever height the frame
// around them ends up with, rather than overflowing it. flexShrink/minHeight don't inherit
// down the tree, so each layer has to declare its own copy of this shape.
const flexFillColumn = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  minHeight: 0,
} as const

export const useStyles = makeStyles({
  list: {
    ...flexFillColumn,
    gap: tokens.spacingVerticalMNudge,
    width: '100%',
    // Fills the (possibly shrunken) frame and scrolls its items instead of clipping them.
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBlock: tokens.spacingHorizontalXXS,
    boxSizing: 'border-box',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  // Renders at exactly the height ChatInput allocated (via allocateComposerHeights) - not
  // flex-shrinkable, so the browser never second-guesses that number. Collapse drives the same
  // flex-basis to 0px; the transition below is what makes both directions glide.
  listFrame: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'var(--context-list-target-height, 0px)',
    minHeight: 0,
    overflow: 'hidden',
  },
  listFrameAnimated: {
    transitionProperty: 'flex-basis',
    transitionDuration: '220ms',
    transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  },
  listFrameInstant: {
    transitionProperty: 'none',
  },
  listContainer: {
    ...flexFillColumn,
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
  },
  scrollFade: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: tokens.spacingVerticalXXL,
    pointerEvents: 'none',
    zIndex: 2,
    opacity: 0,
    transitionProperty: 'opacity, transform',
    transitionDuration: tokens.durationNormal,
    transitionTimingFunction: tokens.curveEasyEase,
  },
  scrollFadeTop: {
    top: 0,
    transform: 'translateY(-20%)',
    backgroundImage: `linear-gradient(to bottom, ${tokens.colorNeutralBackground1} 0%, transparent 100%)`,
  },
  scrollFadeBottom: {
    bottom: 0,
    transform: 'translateY(20%)',
    backgroundImage: `linear-gradient(to top, ${tokens.colorNeutralBackground1} 0%, transparent 100%)`,
  },
  scrollFadeVisible: {
    opacity: 1,
    transform: 'translateY(0)',
  },
})
